import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';
import { BookingPeriods } from './containers/BookingPeriods/index.tsx';
import { CreditCardReceipts } from './containers/CreditCardReceipts/index.ts';
import { PrintPayouts } from './containers/PrintPayouts/index.ts';

export const Finances = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  Invoices: lazy(() => import('./containers/Invoices/index.tsx')),
  ManualInvoice: lazy(() => import('./containers/ManualInvoice/index.tsx')),
  CompanyConfigs: {
    ConfigsList: lazyNamed(() => import('./containers/CompanyConfigs/pages/ConfigsList/index.tsx'), 'ConfigsList'),
    ConfigForm: lazyNamed(() => import('./containers/CompanyConfigs/pages/ConfigForm/index.tsx'), 'ConfigForm'),
  },
  Payouts: {
    Report: lazy(() => import('./containers/Payouts/containers/Reports/index.tsx')),
    Statistics: lazy(() => import('./containers/Payouts/containers/Statistics/index.tsx')),
    Websites: lazyNamed(() => import('./containers/Payouts/containers/Websites/index.tsx'), 'Websites'),
    WebsiteForm: lazyNamed(() => import('./containers/Payouts/containers/WebsiteForm/index.tsx'), 'WebsiteForm'),
    PayoutConfigs: lazyNamed(() => import('./containers/Payouts/containers/PayoutConfigs/index.tsx'), 'PayoutConfigs'),
    Positions: lazyNamed(() => import('./containers/Payouts/containers/Positions/index.tsx'), 'Positions'),
    Details: lazyNamed(() => import('./containers/Payouts/containers/Details/index.tsx'), 'Details'),
    PayoutConfigForm: lazyNamed(() => import('./containers/Payouts/containers/PayoutConfigForm/index.tsx'), 'PayoutConfigForm'),
    CustomPayoutIdRanges: lazyNamed(() => import('./containers/Payouts/containers/CustomPayoutIdRanges/index.tsx'), 'CustomPayoutIdRanges'),
  },
  PrintPayouts,
  Payments: lazyNamed(() => import('./containers/Payments/index.tsx'), 'Payments'),
  CreditCardReceipts,
  BookingPeriods,
};
